/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GatewayAvailability } from './GatewayAvailability';
import {
    GatewayAvailabilityFromJSON,
    GatewayAvailabilityFromJSONTyped,
    GatewayAvailabilityToJSON,
    GatewayAvailabilityToJSONTyped,
} from './GatewayAvailability';
import type { CruiseAttribute } from './CruiseAttribute';
import {
    CruiseAttributeFromJSON,
    CruiseAttributeFromJSONTyped,
    CruiseAttributeToJSON,
    CruiseAttributeToJSONTyped,
} from './CruiseAttribute';
import type { Itinerary } from './Itinerary';
import {
    ItineraryFromJSON,
    ItineraryFromJSONTyped,
    ItineraryToJSON,
    ItineraryToJSONTyped,
} from './Itinerary';
import type { CompactOffers } from './CompactOffers';
import {
    CompactOffersFromJSON,
    CompactOffersFromJSONTyped,
    CompactOffersToJSON,
    CompactOffersToJSONTyped,
} from './CompactOffers';

/**
 * 
 * @export
 * @interface CompactCruise
 */
export interface CompactCruise {
    /**
     * The cruise identifier
     * @type {string}
     * @memberof CompactCruise
     */
    cruiseId: string;
    /**
     * The ship code
     * @type {string}
     * @memberof CompactCruise
     */
    shipCode: string;
    /**
     * The ships name
     * @type {string}
     * @memberof CompactCruise
     */
    shipName: string;
    /**
     * 
     * @type {Itinerary}
     * @memberof CompactCruise
     */
    itinerary: Itinerary;
    /**
     * The duration of the cruise
     * @type {number}
     * @memberof CompactCruise
     */
    duration: number;
    /**
     * The departure date
     * @type {string}
     * @memberof CompactCruise
     */
    departureDate: string;
    /**
     * 
     * @type {CompactOffers}
     * @memberof CompactCruise
     */
    offers: CompactOffers;
    /**
     * Availability of gateways
     * @type {Array<GatewayAvailability>}
     * @memberof CompactCruise
     */
    gateways?: Array<GatewayAvailability>;
    /**
     * Attributes attached to the cruise
     * @type {Array<CruiseAttribute>}
     * @memberof CompactCruise
     */
    cruiseAttributes?: Array<CruiseAttribute>;
}

/**
 * Check if a given object implements the CompactCruise interface.
 */
export function instanceOfCompactCruise(value: object): value is CompactCruise {
    if (!('cruiseId' in value) || value['cruiseId'] === undefined) return false;
    if (!('shipCode' in value) || value['shipCode'] === undefined) return false;
    if (!('shipName' in value) || value['shipName'] === undefined) return false;
    if (!('itinerary' in value) || value['itinerary'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('departureDate' in value) || value['departureDate'] === undefined) return false;
    if (!('offers' in value) || value['offers'] === undefined) return false;
    return true;
}

export function CompactCruiseFromJSON(json: any): CompactCruise {
    return CompactCruiseFromJSONTyped(json, false);
}

export function CompactCruiseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactCruise {
    if (json == null) {
        return json;
    }
    return {
        
        'cruiseId': json['cruiseId'],
        'shipCode': json['shipCode'],
        'shipName': json['shipName'],
        'itinerary': ItineraryFromJSON(json['itinerary']),
        'duration': json['duration'],
        'departureDate': json['departureDate'],
        'offers': CompactOffersFromJSON(json['offers']),
        'gateways': json['gateways'] == null ? undefined : ((json['gateways'] as Array<any>).map(GatewayAvailabilityFromJSON)),
        'cruiseAttributes': json['cruiseAttributes'] == null ? undefined : ((json['cruiseAttributes'] as Array<any>).map(CruiseAttributeFromJSON)),
    };
}

export function CompactCruiseToJSON(json: any): CompactCruise {
    return CompactCruiseToJSONTyped(json, false);
}

export function CompactCruiseToJSONTyped(value?: CompactCruise | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cruiseId': value['cruiseId'],
        'shipCode': value['shipCode'],
        'shipName': value['shipName'],
        'itinerary': ItineraryToJSON(value['itinerary']),
        'duration': value['duration'],
        'departureDate': value['departureDate'],
        'offers': CompactOffersToJSON(value['offers']),
        'gateways': value['gateways'] == null ? undefined : ((value['gateways'] as Array<any>).map(GatewayAvailabilityToJSON)),
        'cruiseAttributes': value['cruiseAttributes'] == null ? undefined : ((value['cruiseAttributes'] as Array<any>).map(CruiseAttributeToJSON)),
    };
}

